import React from 'react'
import { Tooltip } from 'antd'
import { CopyOutlined } from '@ant-design/icons'

interface CopyCommentContextButtonProps {
    onClick: () => void
}

export const CopyCommentContextButton: React.FC<
    CopyCommentContextButtonProps
> = ({ onClick }) => {
    return (
        <Tooltip title="Copy Context to Clipboard">
            <CopyOutlined onClick={onClick} />
        </Tooltip>
    )
}
